import { Dispatch, SetStateAction } from 'react';
import { singleMoneyReceipt } from 'src/Types/module/common/commonTypes';
import { Grid, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import OldMoneyReceiptItem from './OldMoneyReceiptItem';
import CommonDetailItem, {
  formatDate,
  formatValue,
} from 'src/components/CommonDetailItem/CommonDetailItem';

type IProps = {
  showModal?: boolean;
  setShowModal?: Dispatch<SetStateAction<boolean>>;
  singleInvoiceDetails: singleMoneyReceipt;
  setSingleInvoiceInfo?: any;
};

const labelWidth = { xs: '130px', sm: '150px', md: '165px' };

const OldMoneyReceiptBillingInfo = ({ singleInvoiceDetails }: IProps) => {
  const companyName = singleInvoiceDetails?.user_member_company_name ? (
    <Link to={`/member-list/${singleInvoiceDetails?.user_member_id}`}>
      {singleInvoiceDetails.user_member_company_name}
    </Link>
  ) : null;

  const moneyReceiptDate = formatDate(
    singleInvoiceDetails?.created_at || singleInvoiceDetails?.money_receipt_date,
    'DD-MM-YYYY'
  );

  const withdrawDate = formatDate(
    singleInvoiceDetails?.withdraw_date,
    'DD/MM/YYYY'
  );

  return (
    <div>
      <Box sx={{ mt: 3 }}>
        <Grid container spacing={2}>
          <CommonDetailItem
            label='Company name'
            value={companyName}
            labelWidth={labelWidth}
            xs={12}
            sm={6}
            md={4}
          />
          <CommonDetailItem
            label='Money Receipt Date'
            value={moneyReceiptDate}
            labelWidth={labelWidth}
            xs={12}
            sm={6}
            md={4}
          />
          <CommonDetailItem
            label='Money Receipt No'
            value={formatValue(singleInvoiceDetails?.money_receipt_no)}
            labelWidth={labelWidth}
            xs={12}
            sm={6}
            md={4}
          />
          <CommonDetailItem
            label='Voucher No'
            value={formatValue(singleInvoiceDetails?.voucher_no)}
            labelWidth={labelWidth}
            xs={12}
            sm={6}
            md={4}
          />
          <CommonDetailItem
            label='Amount'
            value={
              singleInvoiceDetails?.total_collected_amount
                ? `${Number(singleInvoiceDetails.total_collected_amount).toLocaleString()} BDT`
                : 'N/A'
            }
            labelWidth={labelWidth}
            xs={12}
            sm={6}
            md={4}
          />
          <CommonDetailItem
            label='Bank Name'
            value={formatValue(singleInvoiceDetails?.bank_name)}
            labelWidth={labelWidth}
            xs={12}
            sm={6}
            md={4}
          />
          <CommonDetailItem
            label='Branch Name'
            value={formatValue(singleInvoiceDetails?.branch_name)}
            labelWidth={labelWidth}
            xs={12}
            sm={6}
            md={4}
          />
          <CommonDetailItem
            label='Cheque Number'
            value={formatValue(singleInvoiceDetails?.cheque_number)}
            labelWidth={labelWidth}
            xs={12}
            sm={6}
            md={4}
          />
          <CommonDetailItem
            label='Withdraw Date'
            value={withdrawDate}
            labelWidth={labelWidth}
            xs={12}
            sm={6}
            md={4}
          />
          <CommonDetailItem
            label='Remark'
            value={formatValue(singleInvoiceDetails?.description)}
            labelWidth={labelWidth}
            xs={12}
            sm={12}
            md={12}
          />
        </Grid>

        {/* Course item */}
        <OldMoneyReceiptItem singleInvoiceDetails={singleInvoiceDetails} />
      </Box>
    </div>
  );
};

export default OldMoneyReceiptBillingInfo;
